import { useEffect, useState } from "react";
import { formatarValor } from "./OrderTable";
import api from "../services/api";
import SpinnerLoading from "./SpinnerLoading";
import { Modal } from "../pages/Main/Pedidos/NovoPedido";

const TaxesFromOrderLoad = ({
  cmvFromApi,
  iiFromApi,
  ipipasepFromApi,
  cofinsFromApi,
  icmsFromApi,
  afrmm,
  collectDeFrete,
  outrasDespesasFrete,
  storageTax,
  otherExpenses,
  desembarqueAduaneiroFromApi,
  id,
  pis,
  dollarInFloat,
  afrmmTaxType,
  freightCollectTaxType,
  otherShippingCostsTaxType,
  customsClearanceType,
  otherExpensesType,
  storageTaxType,
}) => {
  useEffect(() => {
    console.log("Últimos 6 parâmetros adicionados:");
    console.log("afrmmTaxType:", afrmmTaxType);
    console.log("freightCollectTaxType:", freightCollectTaxType);
    console.log("otherShippingCostsTaxType:", otherShippingCostsTaxType);
    console.log("customsClearanceType:", customsClearanceType);
    console.log("otherExpensesType:", otherExpensesType);
    console.log("storageTaxType:", storageTaxType);
  }, [
    afrmmTaxType,
    freightCollectTaxType,
    otherShippingCostsTaxType,
    customsClearanceType,
    otherExpensesType,
    storageTaxType,
  ]);

  const [realizedValues, setRealizedValues] = useState({});
  const [realizadoData, setRealizadoData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);

  const sections = [
    {
      title: null,
      items: ["II", "IPI", "PIS", "COFINS", "ICMS", "AFRMM"],
    },
    {
      title: "PREVISTO",
      items: [
        iiFromApi * dollarInFloat,
        ipipasepFromApi * dollarInFloat,
        pis * dollarInFloat,
        cofinsFromApi * dollarInFloat,
        icmsFromApi * dollarInFloat,
        afrmm * dollarInFloat,
      ],
    },
    {
      title: "REALIZADO",
      fields: [
        "ii_realized",
        "ipi_realized",
        "pis_realized",
        "cofins_realized",
        "icms_realized",
        "afrmm_realized",
      ],
    },
    {
      title: null,
      items: [
        "OUTRAS DESPESAS DE FRETE.",
        "ARMAZENAGEM.",
        "DESEMBARAÇO ADUANEIRO",
        "OUTRAS DESPESAS",
        "COLLECT DE FRETE",
      ],
    },
    {
      title: "PREVISTO",
      items: [
        otherShippingCostsTaxType === "FIXED"
          ? outrasDespesasFrete
          : outrasDespesasFrete * dollarInFloat,
        storageTaxType === "FIXED" ? storageTax : storageTax * dollarInFloat,
        customsClearanceType === "FIXED"
          ? desembarqueAduaneiroFromApi
          : desembarqueAduaneiroFromApi * dollarInFloat,
        otherExpensesType === "FIXED"
          ? otherExpenses
          : otherExpenses * dollarInFloat,
        freightCollectTaxType === "FIXED"
          ? collectDeFrete
          : collectDeFrete * dollarInFloat,
      ],
    },
    {
      title: "REALIZADO",
      fields: [
        "other_shipping_expenses_realized",
        "storage_realized",
        "customs_clearance_realized",
        "other_expenses_realized",
        "freight_collect_realized",
      ],
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get(`/order-load/id/${id}`);
        setRealizadoData(data);
      } catch (error) {
        console.log("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [id]);

  const parseValue = (value) => {
    const cleaned = value?.replace(/[^0-9,]/g, "");
    const parsed = parseFloat(cleaned?.replace(/\./g, "").replace(",", "."));
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleInputChange = (field, rawValue) => {
    const formatted = rawValue
      .replace(/[^0-9,]/g, "")
      .replace(/(\..*)\./g, "$1")
      .replace(/(,.*?),(.*,)?/, "$1");

    setRealizedValues((prev) => ({
      ...prev,
      [field]: formatted,
    }));
  };

  useEffect(() => {
    console.log("realized values: ", realizedValues);
  }, [realizedValues]);

  const handleBlur = (field) => {
    const parsed = parseValue(realizedValues[field]);
    setRealizedValues((prev) => ({
      ...prev,
      [field]: parsed.toFixed(2).toString().replace(".", ","),
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const payload = Object.fromEntries(
        Object.entries({
          ii_realized: parseValue(realizedValues.ii_realized),
          ipi_realized: parseValue(realizedValues.ipi_realized),
          pis_realized: parseValue(realizedValues.pis_realized),
          cofins_realized: parseValue(realizedValues.cofins_realized),
          afrmm_realized: parseValue(realizedValues.afrmm_realized),
          icms_realized: parseValue(realizedValues.icms_realized),
          other_shipping_expenses_realized: parseValue(
            realizedValues.other_shipping_expenses_realized
          ),
          storage_realized: parseValue(realizedValues.storage_realized),
          customs_clearance_realized: parseValue(
            realizedValues.customs_clearance_realized
          ),
          other_expenses_realized: parseValue(
            realizedValues.other_expenses_realized
          ),
          freight_collect_realized: parseValue(
            realizedValues.freight_collect_realized
          ),
        }).filter(([_, value]) => value !== 0) // Filtra apenas os valores diferentes de 0
      );

      await api.put(`/order-load/update-order-load/id/${id}`, payload);

      setModalTitle("Sucesso!");
      setModalMessage("Taxas atualizadas com sucesso!");
      setIsErrorModal(false);
      setModalOpen(true);
    } catch (error) {
      console.log(error);

      const errorMessage =
        error.response?.status !== 500
          ? error.response?.data?.error || "Erro desconhecido."
          : "Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.";

      setModalTitle("Erro!");
      setModalMessage(errorMessage);
      setIsErrorModal(true);
      setModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          if (!isErrorModal) window.location.reload();
        }}
        title={modalTitle}
        message={modalMessage}
        isError={isErrorModal}
      />

      <form onSubmit={handleSave}>
        <div className="bg-[#F2F2F2] w-full h-[605px] rounded-2xl my-24 px-14 py-[53px] grid grid-cols-6 justify-center">
          {sections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="flex flex-col gap-4">
              {section.title && (
                <p className="font-bold text-[#FF9533] text-center">
                  {section.title}
                </p>
              )}
              {!section.title && <div className="h-[1rem]" />}

              {section.items?.map((item, index) => (
                <input
                  key={`${sectionIndex}-${index}`}
                  type="text"
                  className={`min-w-[180px] mr-10 min-h-[55px] text-sm rounded text-center self-center ${
                    !section.title
                      ? "bg-transparent font-bold cursor-default focus:outline-none"
                      : "bg-[#E8E9EB]"
                  }`}
                  value={
                    section.title === "PREVISTO"
                      ? formatarValor(item, "BRL")
                      : item
                  }
                  readOnly
                />
              ))}

              {section.fields?.map((field, index) => {
                const apiValue = realizadoData[field];
                const userValue = realizedValues[field];
                const displayValue =
                  apiValue !== null && apiValue !== undefined
                    ? formatarValor(apiValue, "BRL")
                    : userValue;

                return (
                  <input
                    key={`${sectionIndex}-${index}`}
                    type="text"
                    className="min-w-[180px] mr-10 min-h-[55px] text-sm rounded text-center self-center bg-[#E8E9EB]"
                    value={displayValue}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    onBlur={() => handleBlur(field)}
                    readOnly={apiValue !== null && apiValue !== undefined}
                  />
                );
              })}
            </div>
          ))}

          <button
            className="w-full h-10 rounded-lg bg-[#FF9533] text-white mx-auto hover:bg-[#FF8000] ease-linear duration-200 transition-colors transform"
            type="submit"
          >
            {isLoading ? <SpinnerLoading>Salvando</SpinnerLoading> : "Salvar"}
          </button>
        </div>
      </form>
    </>
  );
};

export default TaxesFromOrderLoad;
